( function ( _s ) {
	const isElementBottomVisible = element => {
		const rect = element.getBoundingClientRect();
		const windowHeight = window.innerHeight;
		return rect.bottom <= windowHeight;
	};

	const objectToFormData = obj => {
		const formData = new FormData();

		Object.entries( obj ).forEach( ( [ key, value ] ) => {
			formData.append( key, value );
		} );

		return formData;
	};

	const fetchData = ( ajaxConfig, callback ) => {
		const config = { ...ajaxConfig }; //make a copy to clean up later

		const fetchConfig = {
			url: config.url,
			method: config.method,
		};

		//clean obj
		[ 'url', 'method' ].forEach( prop => delete config[ prop ] );

		//parse config to update url/body
		if ( fetchConfig.method === 'GET' ) {
			fetchConfig.url += '?' + new URLSearchParams( config ).toString();
		} else if ( fetchConfig.method === 'POST' ) {
			fetchConfig.body = objectToFormData( config );
		}

		//handle request
		fetch( fetchConfig.url, fetchConfig )
			.then( response => response.json() )
			.then( data => callback( data ) )
			.catch( error => callback( null, error ) );
	};

	const doAjax = ( _self, ajaxConfig ) => {
		if ( ( ajaxConfig.page !== 1 && _self.noMoreResults ) || _self.ajaxRunning ) return;

		//vars
		const _statusContainer = _self.find( '.ajax-status-container' );

		//set flag
		_self.ajaxRunning = true;
		_statusContainer.attr( 'ajax-status', 'ajax-running' );

		//if page == 1, clean the container first
		if ( ajaxConfig.page && ajaxConfig.page === 1 ) {
			_self.find( '.search-result-card' ).remove();
			//reset flag(s)
			_self.noMoreResults = false;
		}

		//get data from AJAX
		fetchData( ajaxConfig, ( resp, err ) => {
			//set flags
			_statusContainer.attr( 'ajax-status', '' );
			_self.ajaxRunning = false;

			if ( err ) {
				console.log( err );
			} else if ( resp.success ) {
				resp.data.posts.forEach( card => _self.cardsContainer.append( card ) );

				console.log( 'resp', resp );

				if ( ajaxConfig.page === 1 && resp.data.posts.length === 0 ) {
					_statusContainer.attr( 'ajax-status', 'no-results-found' );
					_self.noMoreResults = true;
				}

				if ( resp.data.has_more === false ) {
					_statusContainer.attr( 'ajax-status', 'no-more-results' );
					_self.noMoreResults = true;
				}
			}
		} );
	};

	_s.fn.searchTempate = function () {
		return this.each( el => {
			const _self = _s( el );
			const _searchResultCards = _self.find( '.search-result-cards' );
			const _searchResultCardsContainer = _searchResultCards.find( '.cards-container' );
			const _ajaxStatusContainer = _searchResultCards.find( '.ajax-status-container' );
			const _sortByForm = _self.find( '.custom-form.sort-by' );
			const _sortBy = _sortByForm.find( 'select' );

			const initialAjaxConfig = JSON.parse(
				_searchResultCards.attr( 'ajax-config' ) || '{}'
			);

			let ajaxConfig = initialAjaxConfig;

			_self.ajaxRunning = false;
			_self.noMoreResults = [ 'no-results-found', 'no-more-results' ].includes(
				_ajaxStatusContainer.attr( 'ajax-status' )
			);

			_self.cardsContainer = _searchResultCardsContainer;

			if ( Object.keys( ajaxConfig ).length ) {
				_s( window ).on( 'scroll', () => {
					if (
						! _self.ajaxRunning &&
						! _self.noMoreResults &&
						isElementBottomVisible( _self.el[ 0 ] )
					) {
						//load more
						ajaxConfig = { ...ajaxConfig, ...{ page: ajaxConfig.page + 1 } };
						doAjax( _self, ajaxConfig );
					}
				} );
			}

			if ( _sortBy.length ) {
				_sortBy.on( 'change', () => {
					ajaxConfig = {
						...ajaxConfig,
						...{ order_by: _sortBy.firstElement().value },
						...{ page: 1 },
					};
					doAjax( _self, ajaxConfig );
				} );
			}
		} );
	};

	_s( document ).ready( () => {
		_s( 'body.search .search-results' ).searchTempate();
	} );
} )( window._s );
